module.exports = __webpack_public_path__ + "img/tutorial_bg.4ce2d97a.png";